import { themeConstants } from '@paywithextend/components'
import {
  base_colorAlert,
  base_colorAlertHover,
  base_colorRaisedSurface,
  grey100,
  grey400,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing, table_borderRadius } from 'ext-ui/style/spacing'
import { font_md, font_sm, fontFormLabel } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .NotesInputField {
    display: flex;
    flex-direction: column;

    &-label {
      ${fontFormLabel};
      white-space: nowrap;
      margin-bottom: ${spacing(2)};
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-container {
      position: relative;
    }

    &-textarea {
      width: 100%;
      border-radius: ${table_borderRadius};
      min-height: ${spacing(25)};
      max-height: ${spacing(25)};
      resize: none;
      border: 1px solid ${grey400};
      padding: ${spacing(5)};
      caret-color: ${themeConstants.colors.cta};
      background-color: ${grey100};
      ${fontFormLabel};
      color: ${themeConstants.colors
        .font_primary}; // override fontFormLabel color
      &:hover,
      &:focus {
        background-color: ${base_colorRaisedSurface};
        border: 1px solid ${themeConstants.colors.cta};
        outline: none;
      }
      &::placeholder {
        ${font_md};
        color: ${text_colorTextSecondary};
      }

      &.severe {
        border-color: ${base_colorAlert};

        &:hover,
        &.hovered {
          border-color: ${base_colorAlertHover};
        }
      }
    }

    &-counter {
      margin-top: ${spacing(1)};
      position: absolute;
      top: ${spacing(19)};
      right: ${spacing(2)};
      ${font_sm};
      color: ${text_colorTextSecondary};
    }
  }
`
